import ImagesPressVariousPhotoEightJpg from '@/public/images/press/various/photoEight.jpg';
import ImagesPressVariousPhotoEighteenJpg from '@/public/images/press/various/photoEighteen.jpg';
import ImagesPressVariousPhotoElevenJpg from '@/public/images/press/various/photoEleven.jpg';
import ImagesPressVariousPhotoFifteenJpg from '@/public/images/press/various/photoFifteen.jpg';
import ImagesPressVariousPhotoFiveJpg from '@/public/images/press/various/photoFive.jpg';
import ImagesPressVariousPhotoFourJpg from '@/public/images/press/various/photoFour.jpg';
import ImagesPressVariousPhotoFourteenJpg from '@/public/images/press/various/photoFourteen.jpg';
import ImagesPressVariousPhotoNineJpg from '@/public/images/press/various/photoNine.jpg';
import ImagesPressVariousPhotoNineteenJpg from '@/public/images/press/various/photoNineteen.jpg';
import ImagesPressVariousPhotoOneJpg from '@/public/images/press/various/photoOne.jpg';
import ImagesPressVariousPhotoSevenJpg from '@/public/images/press/various/photoSeven.jpg';
import ImagesPressVariousPhotoSeventeenJpg from '@/public/images/press/various/photoSeventeen.jpg';
import ImagesPressVariousPhotoSixJpg from '@/public/images/press/various/photoSix.jpg';
import ImagesPressVariousPhotoSixteenJpg from '@/public/images/press/various/photoSixteen.jpg';
import ImagesPressVariousPhotoTenJpg from '@/public/images/press/various/photoTen.jpg';
import ImagesPressVariousPhotoThirteenJpg from '@/public/images/press/various/photoThirteen.jpg';
import ImagesPressVariousPhotoThreeJpg from '@/public/images/press/various/photoThree.jpg';
import ImagesPressVariousPhotoTwelveJpg from '@/public/images/press/various/photoTwelve.jpg';
import ImagesPressVariousPhotoTwentyJpg from '@/public/images/press/various/photoTwenty.jpg';
import ImagesPressVariousPhotoTwentyfiveJpg from '@/public/images/press/various/photoTwentyfive.jpg';
import ImagesPressVariousPhotoTwentyfourJpg from '@/public/images/press/various/photoTwentyfour.jpg';
import ImagesPressVariousPhotoTwentyoneJpg from '@/public/images/press/various/photoTwentyone.jpg';
import ImagesPressVariousPhotoTwentythreeJpg from '@/public/images/press/various/photoTwentythree.jpg';
import ImagesPressVariousPhotoTwentytwoJpg from '@/public/images/press/various/photoTwentytwo.jpg';
import ImagesPressVariousPhotoTwoJpg from '@/public/images/press/various/photoTwo.jpg';

export {
  ImagesPressVariousPhotoEightJpg,
  ImagesPressVariousPhotoEighteenJpg,
  ImagesPressVariousPhotoElevenJpg,
  ImagesPressVariousPhotoFifteenJpg,
  ImagesPressVariousPhotoFiveJpg,
  ImagesPressVariousPhotoFourJpg,
  ImagesPressVariousPhotoFourteenJpg,
  ImagesPressVariousPhotoNineJpg,
  ImagesPressVariousPhotoNineteenJpg,
  ImagesPressVariousPhotoOneJpg,
  ImagesPressVariousPhotoSevenJpg,
  ImagesPressVariousPhotoSeventeenJpg,
  ImagesPressVariousPhotoSixJpg,
  ImagesPressVariousPhotoSixteenJpg,
  ImagesPressVariousPhotoTenJpg,
  ImagesPressVariousPhotoThirteenJpg,
  ImagesPressVariousPhotoThreeJpg,
  ImagesPressVariousPhotoTwelveJpg,
  ImagesPressVariousPhotoTwentyJpg,
  ImagesPressVariousPhotoTwentyfiveJpg,
  ImagesPressVariousPhotoTwentyfourJpg,
  ImagesPressVariousPhotoTwentyoneJpg,
  ImagesPressVariousPhotoTwentythreeJpg,
  ImagesPressVariousPhotoTwentytwoJpg,
  ImagesPressVariousPhotoTwoJpg,
};
